import { Label } from '@cian/ui-kit';
import * as React from 'react';

import { useIsDailyrentOnlineBooking } from 'shared/hooks/useIsDailyrentOnlineBooking';

export function InstantBookingLabelContainer() {
  const isOnlineBooking = useIsDailyrentOnlineBooking();

  if (!isOnlineBooking) {
    return null;
  }

  return (
    <Label data-testid="InstantBookingLabel" background="rgba(21, 34, 66, 0.1)" color="black_100">
      Мгновенная бронь
    </Label>
  );
}
